

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

export const VERIFY_CAPTCHA_REQUEST = 'VERIFY_CAPTCHA_REQUEST';
export const VERIFY_CAPTCHA_SUCCESS = 'VERIFY_CAPTCHA_SUCCESS';
export const VERIFY_CAPTCHA_FAILURE = 'VERIFY_CAPTCHA_FAILURE';

export const REFRESH_CAPTCHA_REQUEST = 'REFRESH_CAPTCHA_REQUEST';
export const REFRESH_CAPTCHA_SUCCESS = 'REFRESH_CAPTCHA_SUCCESS';
export const REFRESH_CAPTCHA_FAILURE = 'REFRESH_CAPTCHA_FAILURE';

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';

export const USER_ALL_ORDERS_REQUEST = 'USER_ALL_ORDERS_REQUEST';
export const USER_ALL_ORDERS_SUCCESS = 'USER_ALL_ORDERS_SUCCESS';
export const USER_ALL_ORDERS_FAIL = 'USER_ALL_ORDERS_FAIL';
